import { render } from "./Tools.vue?vue&type=template&id=12f5b482"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AppDev\\__\\_goblinbank\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__